<template>
  <model-crud :model="model" :fields="fields" :include="[]" />
</template>

<script>
import ModelCrud from '@/components/ModelCrud'
import Tag from '@/models/Tag'

export default {
  data () {
    return {
      model: Tag,
      fields: {
        tagName: { label: this.$t('headers.name') },
        color: { label: this.$t('headers.color'), type: 'color' },
        note: {
          label: this.$t('headers.note'),
          fill: true,
          multiLine: true,
          displayLength: 20
        },
        automaticIdent: {
          label: this.$t('headers.automaticIdent'),
          roles: [ 'COMPANY_ADMIN' ],
          rules: [
            (value) => (!value || /^[1234567890+*#]*$/.test(value)) ? true : this.$t('errors.invalidAutomaticIdent')
          ]
        },
        enabled: { label: this.$t('headers.enabled'), type: 'bool', default: true }
      }
    }
  },
  components: {
    ModelCrud
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Tags.vue?4c2c17ab